export default __webpack_public_path__ + "static/media/nodejs.6e615d3e.svg";